import { getOneCmsApiUrl } from '../selectors/selectors';

export default {
  fetch: ({ locale }, action, state) => ({
    url: `${getOneCmsApiUrl(state)}/Internet/travel/hub/${locale?.toLowerCase()}/air-ancillaries.json`,
    opts: {
      method: 'GET',
      credentials: 'omit',
    },
  }),
};
